import { atom } from "jotai";

/**
 * Atom to track resource URIs that have had their onFirstSeen callback invoked.
 * Keyed by chat session ID to isolate state between different chat sessions.
 *
 * This persists across ChatProvider unmount/remount cycles, ensuring that
 * resources that were already "seen" during a previous viewing session
 * don't trigger onFirstSeen again when the user returns to the chat.
 */
export const seenResourceUrisAtom = atom<Record<string, Set<string>>>({});
